export enum RoleClassEnum {
    Town,
    Mafia,
    Neutral,
    Mixed
}